import { render, staticRenderFns } from "./SettingsSection.vue?vue&type=template&id=1ee57921"
import script from "./SettingsSection.vue?vue&type=script&lang=js"
export * from "./SettingsSection.vue?vue&type=script&lang=js"
import style0 from "./SettingsSection.vue?vue&type=style&index=0&id=1ee57921&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports